<!--
 * @Description: 
 * @Autor: Dai YueLin
 * @Date: 2022-10-19 15:18:33
 * @LastEditors: Dai YueLin
 * @LastEditTime: 2022-10-19 15:19:13
-->
<template>
  <div>
    <iframe
      id="frame_vprivacy"
      :key="uuidv4()"
      ref="iframe"
      class="frame_vprivacy"
      :src="urlSrc"
      frameborder="0"
      title=""
    ></iframe>
  </div>
</template>

<script lang="ts" setup>
import { ref, onMounted, onUnmounted, h } from 'vue';
import { useRoute } from 'vue-router';
import { v4 as uuidv4 } from 'uuid';

import { getSession, removeToken } from '@/utils/storage';
import { setToken } from '@/utils/system';
import { loginOut } from '@/api/login';
import { getDgpNotice } from '@/api/system';

const route: any = useRoute();
const path = route.query.path;
const pathId = route.query.pathId;

const xToken = getSession('Admin-Token');
const vprivacyUrl: string = import.meta.env.VITE_GLOB_Vprivacy;
const urlSrc = path
  ? `${vprivacyUrl}/#${path}?token=${xToken}&vp_navigator=0&vp_logo=0&vp_title=1&${pathId}`
  : `${vprivacyUrl}/#/dataInventory/index?token=${xToken}&vp_navigator=0&vp_logo=0&vp_title=1`;

const iframe = ref(null);
onMounted(() => {
  window.addEventListener('message', handleMessage);
  fetchNotice();
});

const fetchNotice = async () => {
  const res = await getDgpNotice();
  const { showFlag, text } = res;
  if (showFlag) {
    window.$dialog.warning({
      title: 'Notice',
      content: () =>
        h('div', {
          innerHTML: text,
        }),
      negativeText: 'Close',
      maskClosable: false,
      style: {
        width: '500px',
      },
    });
  }
};

onUnmounted(() => {
  window.removeEventListener('message', handleMessage);
});

const handleMessage = (event: any) => {
  const { data } = event;
  const jsonData = JSON.parse(data);
  if (jsonData.loginout === 'true') {
    loginOut().then(() => {
      const didlogoutUrl = import.meta.env.VITE_GLOB_DID_LOGOUT_URL;
      removeToken('userInfo');
      removeToken('Admin-Token');
      window.location.href = didlogoutUrl;
    });
  } else if (jsonData.setToken) {
    setToken(jsonData.setToken);
  }
};
</script>

<style lang="scss" scoped>
.frame_vprivacy {
  width: 100%;
  height: calc(100vh - 80px);
}
</style>
